<template>
  <v-dialog
      v-model="open"

      max-width="432"
      width="76vmin"
      overlay-opacity="0.8"
      class="dialog"

  >
    <v-btn x-small fab class="close-button" color="gray"
           @click="open=false">
      <v-icon>mdi-close</v-icon>
    </v-btn>

    <v-card class="panel">


      <div class="display">{{display(current_number)}}
        <span
            style="position: absolute;top:0;left:8px;font-size: 0.7em">
          {{last_number!==''?$helper.number_format(last_number,0,4):''}}{{operan}}</span>
      </div>
      <table style="padding: 0;margin: 0">
        <tr>
          <td>
            <div class="button" @click="onPress('7')">7</div>
          </td>
          <td>
            <div class="button" @click="onPress('8')">8</div>
          </td>
          <td>
            <div class="button" @click="onPress('9')">9</div>
          </td>
          <td>
            <div class="button oper" @click="onPress('%')">&#37;</div>
          </td>
          <td>
            <div class="button bk" @click="onPress('<')">
              <v-icon>mdi-chevron-double-left</v-icon>
            </div>
          </td>
        </tr>
        <tr>
          <td>
            <div class="button" @click="onPress('4')">4</div>
          </td>
          <td>
            <div class="button" @click="onPress('5')">5</div>
          </td>
          <td>
            <div class="button" @click="onPress('6')">6</div>
          </td>
          <td>
            <div class="button oper bigger_font" @click="onPress('x')">&#215;</div>
          </td>
          <td>
            <div class="button oper bigger_font" @click="onPress('/')">&#247;</div>
          </td>
        </tr>
        <tr>
          <td>
            <div class="button" @click="onPress('1')">1</div>
          </td>
          <td>
            <div class="button" @click="onPress('2')">2</div>
          </td>
          <td>
            <div class="button" @click="onPress('3')">3</div>
          </td>
          <td rowspan="2">
            <div class="button button_high oper  bigger_font" @click="onPress('+')">
              &#43;
            </div>
          </td>
          <td>
            <div class="button oper  bigger_font" @click="onPress('-')">
              &#45;
            </div>
          </td>
        </tr>
        <tr>
          <td>
            <div class="button" @click="onPress('0')">0</div>
          </td>
          <td>
            <div class="button small" @click="onPress('00')">00</div>
          </td>
          <td>
            <div class="button" @click="onPress('.')">.</div>
          </td>
          <td>
            <div class="button oper  bigger_font" @click="onPress('=')">=</div>
          </td>
        </tr>
        <tr>
          <td colspan="2">
            <div class="button button_long ac" @click="onPress('ac')">AC</div>
          </td>
          <td>
            <div class="button" @click="onPress('+-')">&#177;</div>
          </td>
          <td></td>
          <td>
            <div class="button small primary" @click="onPress('ok')">
              <v-progress-circular
                  v-if="loading"
                  indeterminate
                  color="white"
              ></v-progress-circular>
              {{loading?'':'OK'}}
            </div>
          </td>
        </tr>
      </table>
    </v-card>
  </v-dialog>
</template>
<style lang="scss" scoped>
  .v-dialog {
    margin: 0;
    overflow: visible;
  }

  .close-button {
    float: right;
    margin-top: 0;

  }

  .view {
    position: relative;
    /*background: #FF0000;*/
  }

  .panel {
    margin-top: 16px;

    background: #EEEEEE;
    padding: 1vmin;
    border-radius: 4vmin;
  }

  .display {
    position: relative;
    display: block;
    border: #636b6f 1px solid;
    /*float: left;*/
    width: calc((100vmin - 48px) * 82 / 100);
    height: calc((100vmin - 48px) * 14.25 / 100);
    max-width: 406px;
    max-height: 75px;
    background: #f8fafc;
    text-align: right;
    /*vertical-align: center;*/
    font-size: 8vmin;
    line-height: 1;
    margin: 1vmin;
    border-radius: 2vmin !important;
    padding-top: 3vmin;
    padding-left: 2vmin;
    padding-right: 2vmin;
  }

  .button {
    max-width: 75px;
    max-height: 75px;
    color: rgba(0, 0, 0, 0.54);
    display: block;
    border: #636b6f 1px solid;
    float: left;
    width: calc((100vmin - 48px) * 14.25 / 100);
    height: calc((100vmin - 48px) * 14.25 / 100);
    background: #f8fafc;
    text-align: center;
    /*vertical-align: center;*/
    font-size: 6vmin;
    line-height: 1;
    margin: calc((100vmin - 48px) * 0.8 / 100);
    border-radius: 2vmin;
    padding-top: 4vmin;
    .v-icon {
      font-size: 8vmin !important;
    }
    &.small {
      font-size: 4vmin;
      padding-top: 5vmin;
    }
    &.oper {

      background: #BDBDBD;
    }
    &.bigger_font {
      padding-top: 0.8vmin;
      font-size: 12vmin;
    }
    &.ac {
      background: #757575;
      padding-top: 3vmin;
    }
    &.bk {
      background: #757575;
      padding-top: 2vmin;
    }

    &.active {
      background: #FF0000 !important;
    }
  }

  .button_long {
    width: calc((100vmin - 48px) * 32 / 100);
    max-width: 165px;
  }

  .button_high {
    &.bigger_font {
      padding-top: 7vmin;
    }
    height: calc((100vmin - 48px) * 32 / 100);
    max-height: 165px;
  }

  .theme--dark .panel {
    background: #333333;
  }

  .theme--dark .display {
    background: #333333;
    color: #f8fafc;
  }

  .theme--dark .button {
    background: #000000;
    color: #999999;
    &.oper {
      background: #666666;
    }
    &.ac {
      background: #222222;
      color: #999999 !important;
    }
    &.primary {
      color: #FFFFFF;
    }
  }

  .theme--dark.v-icon {
    color: #999999 !important;
  }

  @media only screen and (min-width: 600px) {
    .display {
      margin: 4px;
      padding-top: 12px;
      font-size: 48px;
    }
    .button {
      margin: 1.5px;
      border-radius: 16px;
      padding-top: 14px;
      font-size: 48px;
      .v-icon {
        font-size: 36px !important;
      }
      &.bigger_font {
        padding-top: 0;
        font-size: 72px;
        line-height: 1;
      }
      &.small {
        font-size: 36px;
        padding-top: 20px;
      }
      &.ac {
        padding-top: 12px;
      }
      &.bk {
        padding-top: 8px;
      }
    }
    .button_high {
      &.bigger_font {
        padding-top: 40px;
      }
    }
    .panel {
      padding: 8px
    }

  }


</style>

<script lang="ts">

  import {Component, Vue} from 'vue-property-decorator'

  import Helper from '../services/Helper.js'


  @Component({
    components: {},
  })
  export default class CalculatorDialog extends Vue {

    // @Prop({
    //   default: (number) => {
    //   },
    // })
    onApply: Function = () => {
    }



    // toggleOpen(start_number) {
    //   this.current_number = start_number
    // }

    is_string: boolean = false
    open: boolean = false

    start_number: number = 0

    loading: boolean = false
// active: string = ''
    last_number: string = ''
    current_number: string = ''
    operan: string = ''

    created() {
      this.$root.$on('openCalculator', this.onOpen)
    }

    display(text) {
      if (this.is_string) return text
      if (text == null) text = ''
      let dataInt = text
      let middle = ''
      let dataFaction = ''
      const data = text.toString().split('.')
      if (data.length > 1) {
        dataInt = data[0]
        middle = '.'
        dataFaction = data[1]

      }

      return Helper.number_format(dataInt, 0) + middle + dataFaction.substr(0, 6)
    }

    onOpen({number, is_string, onApply}) {
      console.log('calculator mounted')
      this.start_number = Math.round(parseFloat(number) * 1000000) / 1000000
      this.is_string = is_string
      this.operan = '='
      this.last_number = ''
      this.current_number = number
      this.onApply = onApply
      this.open = true
      //debugger
    }

    async onPress(char) {
      switch (char) {
        case 'ac':
          this.last_number = ''
          this.current_number = ''
          this.operan = ''
          break
        case '+':
          if (this.current_number == '') break
          if (this.operan != '' && this.operan != char)
            this.onPress('=')
          if (this.last_number !== '') {
            this.current_number = '' + (parseFloat(this.last_number) + parseFloat(this.current_number))
          }
          this.operan = char
          this.last_number = ''
          break

        case '-':
          if (this.current_number == '') break
          if (this.operan != '' && this.operan != char)
            this.onPress('=')
          if (this.last_number !== '') {
            this.current_number = '' + (parseFloat(this.last_number) - parseFloat(this.current_number))
          }
          this.operan = '-'
          this.last_number = ''
          break
        case 'x':
          if (this.current_number == '') break
          if (this.operan != '' && this.operan != char)
            this.onPress('=')
          if (this.last_number !== '') {
            this.current_number = '' + (parseFloat(this.last_number) * parseFloat(this.current_number))
          }
          this.operan = char
          this.last_number = ''
          break
        case '/':
          if (this.current_number == '') break
          if (this.operan != '' && this.operan != char)
            this.onPress('=')
          if (this.last_number !== '') {
            this.current_number = '' + (parseFloat(this.last_number) / parseFloat(this.current_number))
          }
          this.operan = char
          this.last_number = ''
          break
        case '<':
          if (this.current_number.length > 0) {
            this.current_number = this.current_number.substr(0, this.current_number.length - 1)
          }
          break

        case '%':
          if (this.current_number.length > 0) {
            this.current_number = '' + (parseFloat(this.last_number) * parseFloat(this.current_number) / 100)
          }
          break

        case '+-':
          if (this.current_number.length > 0 && this.current_number[0] == '-') {
            this.current_number = this.current_number.substr(1)
          } else {
            this.current_number = '-' + this.current_number
          }
          break

        case '=':
          if (this.operan != '=')
            this.onPress(this.operan)
          this.operan = '='

          break

        case 'ok':
          if (this.operan != '=')
            this.onPress(this.operan)
          this.operan = '='

          if (this.is_string) {
            await this.onApply(this.current_number)
            this.loading = false
          } else {

            if (this.current_number === '') this.current_number = '0'
            let number = Math.round(parseFloat(this.current_number) * 1000000) / 1000000

            if (this.start_number != number) {
              this.loading = true

              await this.onApply(number)
              this.loading = false
            }
          }
          this.open = false


          break

        default:
          if (this.operan == '=') {
            this.operan = ''
            this.last_number = ''
            this.current_number = ''
          } else if (this.operan != '' && this.last_number === '') {
            this.last_number = this.current_number
            this.current_number = ''
          }
          if (char == '.' && this.current_number == '') {
            this.current_number = '0'
          }

          this.current_number += char
      }
    }

  };

</script>
